import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExpensePendingRequestService } from './expensependingrequest.service';
import { global } from '../../shared/global';
declare var $: any;

@Component({
  selector: 'app-expensependingrequest',
  templateUrl: './expensependingrequest.component.html',
  styleUrls: ['./expensependingrequest.component.css']
})
export class ExpensependingrequestComponent implements OnInit {
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  dropDownData: any;
  stds: any;
  boards: any;
  mediums: any;
  years: any;
  submitted: boolean;
  HashCode: any;
  ExpenseMainlist: any;
  ExpenseDetaillist: any;
  btnsubmittext = "Submit";
  schoolname: any;

  constructor(private service: ExpensePendingRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.GetExpenseDetailList();
});
    $("#searchtext").val("");
    this.GetExpenseDetailList();
  }
  GetExpenseDetailList() {
    this.spinner.show();
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      //HashCode: this.HashCode
      YearID : localStorage.getItem("YearID"),
      SearchText : search,
    };
    this.service.getAllPendingExpenseDetailList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.ExpenseMainlist = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
        //  this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.ExpenseMainlist = this.responseData.pendingExpenseDetailList;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  onSubmit(){
    var approveCount=0;
    var rejectCount=0;
    
    for (var i = 0; i < this.ExpenseDetaillist.length; i++) {
      if ($('#Accept' + i).prop("checked")) {
        this.ExpenseDetaillist[i]["IsApproved"] = 1;
        approveCount++;
      }
      else if ($('#Reject' + i).prop("checked")) {
        rejectCount++;
        if ($('#Reject' + i).prop("checked") && $('#Remark' + i).val().toString().trim() == "") {
          this.toastr.error("Remark is required while rejecting request")
          return;
        }
        this.ExpenseDetaillist[i]["IsApproved"] = 2;
      }
      else {
        if ($('#Remark' + i).val().toString().trim().length > 0) {
          this.toastr.error("Add status if you want to add remarks")
          return;
        }
        this.ExpenseDetaillist[i]["IsApproved"] = 0;
      }
      this.ExpenseDetaillist[i]["Remark"] = $('#Remark' + i).val().toString().trim();
    }
    if(approveCount == 0 && rejectCount == 0){
      this.toastr.error("Update atleast one record to save details")
      return;
    }
    this.spinner.show();
    // this.SchoolFeesIncrease = this.FeesIncreaseDetail;
    //this.data.UpdateAdminFeesIncreaseDetails = this.EmployeeDetaillist;
    var mainindex = $("#index").val();

    const data = {
      PendingExpenseLists : this.ExpenseDetaillist,
      Hashcode: this.ExpenseMainlist[mainindex]["HashCode"]
    }
    this.service.AcceptRejectExpenseRequest(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.toastr.success(this.responseData.message);
          this.GetExpenseDetailList();
          this.closeForm();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  View(i){
    this.ExpenseDetaillist = this.ExpenseMainlist[i]["PendingExpenseLists"];
    $("#index").val(i);
    $('#detailModal').modal('show');
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.ExpenseDetaillist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  closeForm(){
    this.ExpenseDetaillist = [];
    $("#index").val(0);
    $('#detailModal').modal('hide');
  }
}
